import '../../styles/pages/category.scss';
import generateTabs from '../components/generateTabs';
import '../components/category-hero-tabs-slider';
import '../components/war-slider';

// IMPORTANT: Ten elements must be loaded
const data = [
    {
        title: "До Європи за захистом. Що означає позов Ахметова до Європейського суду з прав людини",
        time: "14:59",
        withIcon: {
            icon: `<svg width="16" height="16" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" > <path fill-rule="evenodd" clip-rule="evenodd" d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20.0899 13.1039L26.1934 17.4765V17.4796C26.5984 17.77 26.9277 18.1494 27.1547 18.5872C27.3817 19.0251 27.5 19.5089 27.5 19.9997C27.5 20.4905 27.3817 20.9744 27.1547 21.4122C26.9277 21.8501 26.5984 22.2295 26.1934 22.5199L20.0899 26.8925C19.6135 27.235 19.0492 27.4416 18.4598 27.4893C17.8704 27.5371 17.279 27.4241 16.7514 27.1629C16.2238 26.9018 15.7807 26.5027 15.4715 26.0101C15.1623 25.5175 14.9991 24.9508 15 24.3729V15.6234C15.0005 15.0461 15.1646 14.4803 15.4741 13.9885C15.7836 13.4968 16.2264 13.0984 16.7535 12.8375C17.2806 12.5766 17.8713 12.4634 18.4602 12.5104C19.0491 12.5574 19.6132 12.7628 20.0899 13.1039Z" fill="#979EA9" /> </svg>`,
            title: 'Новина з відео',
        },
        url: "#",
    },
    {
        title: "До Європи за захистом. Що означає позов Ахметова до Європейського суду з прав людини",
        time: "14:59",
        withIcon: {
            icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M10.4972 12.1696C10.4972 11.1696 9.8099 9.8029 8.5639 8.3209C8.49494 8.23863 8.40858 8.1727 8.31105 8.12785C8.21351 8.083 8.10724 8.06037 7.9999 8.06157V8.06157C7.89177 8.06108 7.78482 8.08414 7.6865 8.12915C7.58818 8.17417 7.50085 8.24006 7.43057 8.32224C6.06657 9.92024 5.3999 11.3336 5.51523 12.4169C5.56062 12.7594 5.67808 13.0884 5.85987 13.3823C6.04166 13.6761 6.28365 13.9281 6.5699 14.1216C6.97483 14.4536 7.47671 14.645 7.9999 14.6669C8.66202 14.6662 9.29681 14.4029 9.765 13.9347C10.2332 13.4665 10.4965 12.8317 10.4972 12.1696Z" fill="#FF3434" /> <path d="M11.0859 1.93323C10.5619 1.48789 10.0119 1.02123 9.45195 0.511893C9.23961 0.319114 8.9877 0.175075 8.71385 0.0898585C8.44001 0.00464206 8.15085 -0.019692 7.86661 0.0185598C7.59114 0.0550441 7.32703 0.151573 7.09295 0.301327C6.85888 0.451081 6.66054 0.650408 6.51195 0.885226C5.71754 2.21311 5.15569 3.66689 4.85061 5.18389C4.73126 5.01106 4.62517 4.82943 4.53328 4.64056C4.43892 4.44175 4.29682 4.26939 4.11965 4.13885C3.94248 4.00831 3.73576 3.92365 3.51791 3.89243C3.30007 3.8612 3.07789 3.88438 2.87119 3.9599C2.66448 4.03542 2.47969 4.16093 2.33328 4.32523C1.21548 5.46816 0.595856 7.00728 0.609947 8.60589C0.594488 10.2389 1.12557 11.8301 2.11869 13.1264C3.11181 14.4228 4.50993 15.3497 6.09061 15.7599C6.69584 15.9122 7.3172 15.991 7.94128 15.9946C7.14377 15.9648 6.37723 15.6781 5.75595 15.1772C5.32555 14.8743 4.96366 14.4843 4.69376 14.0325C4.42386 13.5806 4.25198 13.0771 4.18928 12.5546C4.03595 11.0812 4.78461 9.36589 6.41461 7.45656C6.61016 7.22734 6.85325 7.04342 7.12701 6.91759C7.40078 6.79176 7.69865 6.72703 7.99995 6.72789H8.00661C8.30703 6.72814 8.60378 6.79388 8.87619 6.92053C9.1486 7.04718 9.39013 7.2317 9.58395 7.46123C10.6093 8.67923 11.8326 10.4846 11.8326 12.1686C11.8311 13.139 11.4616 14.0728 10.7985 14.7814C10.1354 15.49 9.22818 15.9207 8.25995 15.9866C10.1744 15.9249 11.9896 15.1204 13.3211 13.7434C14.6526 12.3665 15.3958 10.5253 15.3933 8.60989C15.3899 5.58989 13.3953 3.89656 11.0859 1.93323Z" fill="#FF3434" /> </svg>`,
            title: 'Термінова новина',
        },
        isUrgent: true,
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
    {
        title: "Стало відомо, коли ЄС може узгодити сьомий пакет санкцій проти рф",
        time: "14:59",
        url: "#",
    },
]

generateTabs('sidebar-last', {isLoadMore: false, data});
